// Constants used only by the Who's Who feature. Anything shared with another
// feature (THEME_COLOR, PILL_RADIUS_FILL, PHONE_TOOL_USER_BASE) stays in the
// top-level constants.js.

// Badge-photo URL prefix; append `${alias}.jpg`.
export const PROFILE_PHOTO_BASE = "/photos/";

// Square avatar edge, in px. Half of this is used as the fill radius for a full circle.
export const AVATAR_SIZE = 48;

// Organization pill geometry.
export const CHIP_BORDER_RADIUS = 13;
export const CHIP_HEIGHT = 20;
export const CHIP_FONT_SIZE = 12;

// V2 organization selector behavior and presentation.
export const MAX_ORG_PILLS = 5;
export const ORG_COLOR_MARKER_SIZE = 8;
export const ALL_ORGS_VALUE = 0;
export const ALL_ORGS_LABEL = "All orgs";

// V2 relationship-frequency display threshold. Backend relevance ranking remains 50.
export const REGULAR_COLLABORATOR_MIN_MEETINGS = 11;

// Distinct org accent colours, spread evenly around the hue wheel by the golden angle so
// adjacent orgs stay visually far apart no matter how many there are.
const ORG_COLOR_START_HUE = 170;
const ORG_COLOR_GOLDEN_ANGLE = 137.508;

// Render states for the Who's Who panel, passed as the `state` prop.
export const WHOS_WHO_STATE = {
  LOADING: "loading",
  LOADED: "loaded",
  ERROR: "error",
};

export const orgColor = (index) =>
  `hsl(${(ORG_COLOR_START_HUE + index * ORG_COLOR_GOLDEN_ANGLE) % 360}, 70%, 30%)`;
